import { create } from '../../../utilities/action-helpers';
import * as actions from './actions';

export const loadRelatedProducts = create(actions.LOAD_RELATED_PRODUCTS_DATA);
export const setRelatedProductsStatus = create(actions.SET_RELATED_PRODUCTS_STATUS);
export const setRelatedProductsData = create(actions.SET_RELATED_PRODUCTS_DATA);
